import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContainer, PieChart, Pie, Legend, Tooltip, LabelList, Cell } from 'recharts';
import { Card } from 'antd';

import { loadDashboardData } from '../actions/dashboardActions';
import { getOrgList } from '../../../actions/commonActions';
import ConnectLoading from '../../../components/ConnectLoading';
import { setBreadcrumb } from '../../../actions/commonActions';


class AdminDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dashBoardData: undefined
    }
    this.props.setBreadcrumb('');
    this.loadDashboardData();
  }

  loadDashboardData = async () => {
    await this.props.loadDashboardData();
    await this.props.getOrgList();
  }

  getOrgDashBoard = (org) => {
    let orgData = this.props.orgUserStatusCounts.has(org.org_id) ? this.props.orgUserStatusCounts.get(org.org_id) : { active: 0, inactive: 0 };
    let data = [];
    data.push({ name: 'Active Users', value: orgData.active, color: 'green' });
    data.push({ name: 'Inactive Users', value: orgData.inactive, color: 'red' });

    const total = data.reduce((total, d) => {
      return total + d.value;
    }, 0);

    return (
      <div className='pure-u-1 pure-u-sm-1-2 pure-u-lg-1-3 epar__dashboard--card' key={org.org_id}>
        <Card title={org.name}>
          <div className='epar__chart__container'>
            <Fragment>
              {total === 0 && 'No Users'}
              {total !== 0 &&
                <ResponsiveContainer>
                  <PieChart width={800} height={400}>
                    <Pie isAnimationActive={false} dataKey='value' nameKey='name' data={data} innerRadius={80} outerRadius={120}>
                      {
                        data.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={entry.color} />
                        ))
                      }
                      <LabelList dataKey="value" position="inside" stroke="black" content={content => this.renderLabel(content.value, total)} />
                    </Pie>
                    <Legend />
                    <Tooltip />
                  </PieChart>
                </ResponsiveContainer>
              }
            </Fragment>
          </div>
        </Card>
      </div>

    )
  }

  renderLabel = (value, total) => {
    return `${(value * 100.0 / total).toFixed(0)}%`;
  };

  render() {
    if (!this.props.orgList || !this.props.orgUserStatusCounts) {
      return <ConnectLoading />
    }
    return (
      <div className='pure-g'>
        <div className='pure-u-1'>
          <div className='epar__dashboard--container'>
            <div className='pure-g'>
              <Fragment>
                {this.props.orgList.map(org => this.getOrgDashBoard(org))}
              </Fragment>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, props) {
  return {
    orgList: state.getIn(['orgState', 'orgList']),
    orgUserStatusCounts: state.getIn(['dashboardState', 'orgUserStatusCounts'])
  }
}

function mapDispatchToProps(dispatch) {
  return {
    loadDashboardData: bindActionCreators(loadDashboardData, dispatch),
    getOrgList: bindActionCreators(getOrgList, dispatch),
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminDashboard);
